import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import Logo from '../Assest/images/logo.png';

const LoadingScreen = () => (
  <AnimatePresence>
    <motion.div
      className="fixed inset-0 z-50 flex items-center justify-center bg-gradient-to-br from-rose-50 via-white to-orange-50"
      initial={{ opacity: 1 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.8 }}
    >
      <motion.div
        className="text-center"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <motion.img 
          src={Logo} 
          alt="vital Source Logo" 
          className="h-16 md:h-20 mx-auto mb-2"
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5 }}
        />
        <motion.p
          className="text-3xl sm:text-4xl md:text-5xl font-light text-gray-900 tracking-[0.3em]"
          animate={{
            opacity: [0, 1, 1, 0],
            y: [20, 0, 0, -20],
          }}
          transition={{
            duration: 2,
            times: [0, 0.2, 0.8, 1],
          }}
        >
        Vital Source
        </motion.p>
        <motion.div
          className="mt-6 h-[1px] w-0 bg-orange-500 mx-auto"
          animate={{ width: 120 }}
          transition={{ duration: 1, delay: 0.5 }}
        />
      </motion.div>
    </motion.div>
  </AnimatePresence>
);

export default LoadingScreen;